import * as React from 'react';
import './../index.css';
import './../fonts/Bakerie/BakerieSmoothCondensed-Black.otf';
import { roundToDollars } from '../utils/MoneyUtils';
import { Timestamp } from "firebase/firestore";
import { CustomizedTypeahead } from './CustomizedTypeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';
import ToggleButton from 'react-toggle-button';

import {
  Button,
  Container,
  InputGroup,
  Form,
  Row,
  Col,
  Modal,
  Table,
  Stack,
} from "react-bootstrap";

import {
  makeIngredientMap,
  recipeNameExists,
  recordHistory,
  loadHistoryMap,
  Recipe,
  documentToRecipe,
  getRecipe,
  recalculateCosts,
  saveRecipe,
  getDocData,
} from '../data/RecipeData';

import { getIngredientMapsFromDB, IngredientMaps } from '../data/IngredientData';
import { Settings, getSettings, documentToSettings } from '../data/SettingsData';
import { getReferenceName } from '../utils/ReferendeUtils';
export class RecipeForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      ingredientMaps: new IngredientMaps(),
      recipeIngredientMap: new Map(),
      recipeName: "",
      docRef: "",
      recipe: new Recipe(),
      validated: false,
      isOpen: false,
      showForm: false,
      modalString: "",
      chosenIngredient: "",
      chosenQuantity: 0,
      deleteDocRef: "",
      deleteDocDescription: "",
      isDeleteIngredientConfirmOpen: false,
      historyMap: new Map(),
      settings: new Settings(),
    };

    this.changeValue = this.changeValue.bind(this);
    this.changeChosenIngredientValue = this.changeChosenIngredientValue.bind(this);
    this.changeChosenIngredient = this.changeChosenIngredient.bind(this);
    this.handleClose = this.handleClose(this);
    this.COLLECTION = "recipes";
  }

  handleClose = () => this.setState({ isOpen: false });

  toggleShowForm = () => {
    this.setState({
      showForm: !this.state.showForm,
    });
  }

  addIngredient = () => {
    /**
     * First remove the ingredient if it exists.
     */
    let cleanedIngredients = this.state.recipe.ingredients.filter(ingredient => !ingredient.startsWith(this.state.chosenIngredient.document_reference));
    cleanedIngredients.push(this.state.chosenIngredient.document_reference + ":" + this.state.chosenQuantity);

    let updatedRecipe = this.state.recipe;
    updatedRecipe.ingredients = cleanedIngredients;

    this.setState({
      showForm: !this.state.showForm,
      chosenIngredient: "",
      chosenQuantity: 0,
      recipe: recalculateCosts(this.state.settings, updatedRecipe, this.state.ingredientMaps.ingredientMap),
    });
  }

  toggleDeleteModal = (ingredientDocRef, description) => {
    this.setState({
      deleteDocRef: ingredientDocRef,
      deleteDocDescription: description,
      isDeleteIngredientConfirmOpen: !this.state.isDeleteIngredientConfirmOpen,
    });
  }

  handleDelete = async (ingredientDocRef) => {
    let cleanedIngredients = new Array();
    cleanedIngredients = this.state.recipe.ingredients.filter(ingredient => ingredient.indexOf(ingredientDocRef) === -1);

    let updatedRecipe = this.state.recipe;
    updatedRecipe.ingredients = cleanedIngredients;

    this.setState({
      chosenIngredient: "",
      chosenQuantity: 0,
      isDeleteIngredientConfirmOpen: !this.state.isDeleteIngredientConfirmOpen,
      recipe: recalculateCosts(this.state.settings, updatedRecipe, this.state.ingredientMaps.ingredientMap),
    });
  }

  async getExistingDocument(settings) {
    /**
     * get the recipe data.
     */
    let existingRecipeDoc = await getRecipe(this.props.docRef);
    let tempRecipe = existingRecipeDoc.data();
    console.log("existingRecipeDoc loaded: " + tempRecipe.name);


    let existingRecipe = documentToRecipe(existingRecipeDoc);
    if (!existingRecipe.low_profit_index || existingRecipe.low_profit_index === 0) {
      existingRecipe.low_profit_index = settings.low_profit_index;
    }
    if (!existingRecipe.note) {
      existingRecipe.note = "";
    }
    return existingRecipe;
  }

  async loadSettings() {
    let docReference = getReferenceName(this.props.context.user.email);
    let tempSettingsDoc = await getSettings(docReference);
    let settings = documentToSettings(tempSettingsDoc);
    return settings;
  }

  async loadData() {
    let tempIngrediantMaps = await getIngredientMapsFromDB();
    let tempSettings = await this.loadSettings();
    let existingRecipe = new Recipe();
    let recipeName = '';
    let documentRef = this.props.docRef;
    let newHistoryMap = new Map();

    if (this.props.docRef !== '') {
      existingRecipe = await this.getExistingDocument(tempSettings);
      recipeName = existingRecipe.name;
      if (this.props.mode === 'Copy') {
        documentRef = '';
        existingRecipe.history = new Array();
      } else {
        if (existingRecipe.history && existingRecipe.history.length !== 0) {
          newHistoryMap = await loadHistoryMap(existingRecipe.history);
        }
      }
      existingRecipe = await recalculateCosts(tempSettings, existingRecipe, tempIngrediantMaps.ingredientMap);
      this.setState({
        docRef: documentRef,
      });
    }

    this.setState({
      ingredientMaps: tempIngrediantMaps,
      settings: tempSettings,
      recipeName: recipeName,
      recipe: existingRecipe,
      historyMap: newHistoryMap,
    });
  }

  async componentDidMount() {
    await this.loadData();
  }

  changeChosenIngredientValue(event) {
    if (event.target.id === 'ingredient') {
      this.setState({ chosenIngredient: event.target.value });
    } else if (event.target.id === 'quantity') {
      this.setState({ chosenQuantity: event.target.value });
    }
  }

  changeChosenIngredient(ingredients) {
    if (ingredients.length !== 0) {
      let ingredient = ingredients[0];
      this.setState({ chosenIngredient: ingredient });
    }

  }


  changeValue(event) {
    let tempRecipe = this.state.recipe;
    if (event.target.id === 'name') {
      tempRecipe.name = event.target.value;
    } else if (event.target.id === 'note') {
      tempRecipe.note = event.target.value;
    } else if (event.target.id === 'makes_qty') {
      tempRecipe.makes_qty = event.target.value;
      tempRecipe = recalculateCosts(this.state.settings, tempRecipe, this.state.ingredientMaps.ingredientMap);
    } else if (event.target.id === 'hours_taken') {
      tempRecipe.hours_taken = event.target.value;
      tempRecipe = recalculateCosts(this.state.settings, tempRecipe, this.state.ingredientMaps.ingredientMap);
    } else if (event.target.id === 'low_profit_index') {
      tempRecipe.low_profit_index = event.target.value;
      tempRecipe = recalculateCosts(this.state.settings, tempRecipe, this.state.ingredientMaps.ingredientMap);
    } else if (event.target.id === 'last_update') {
      tempRecipe.last_update = event.target.value;
    }

    this.setState({
      recipe: tempRecipe,
    });

  }

  saveChangedRecipe = async (event) => {
    event.preventDefault();

    /**
     * Do form validation.
     */
    const form = event.currentTarget;
    let documentReference = "";
    if (this.state.recipe.name !== '' && (this.props.mode === 'Copy' || this.props.mode === 'Add')) {
      documentReference = getReferenceName(this.state.recipe.name);
      let nameElement = document.getElementById('name');
      nameElement.setCustomValidity('');
      let exists = await recipeNameExists(documentReference);
      if (exists) {
        let nameElement = document.getElementById('name');
        nameElement.setCustomValidity("A recipe with this name already exists");
      }
    } else {
      documentReference = this.state.recipe.document_reference;
    }

    if (form.checkValidity() === false) {
      this.setState({ validated: true });
      form.reportValidity();
      return;
    }

    let newHistoryList = new Array();
    let newHistoryMap = new Map();
    let now = Timestamp.now();

    let recipe = this.state.recipe;
    if (this.props.mode === 'Edit') {
      if (this.state.recipe.history && this.state.recipe.history.length !== 0) {
        newHistoryList = this.state.recipe.history;
      }
      await recordHistory(newHistoryList, now, this.state.recipe, documentReference);
      recipe.history = newHistoryList;
    }

    recipe = recalculateCosts(this.state.settings, this.state.recipe, this.state.ingredientMaps.ingredientMap);

    let docData = getDocData(recipe);

    await saveRecipe(documentReference, docData);

    this.setState({
      docRef: "",
      recipe: new Recipe(),
      validated: false,
      isOpen: true,
      modalString: "Recipe added!",
      deleteDocRef: "",
      deleteDocDescription: "",
      historyMap: newHistoryMap,
    });
    /**
     * toggle the show form so the add/edit is not shown.
     */
    this.props.toggleForm();
  }

  renderHistoryTableRow = (historyDocRef, historyRecord) => {
    let updatedDate = historyRecord.updateDate.toDate().toString();
    let oldValue = historyRecord.oldValue;
    let newValue = historyRecord.newValue;
    if (historyRecord.field === 'ingredients') {
      let oldValueString = '';
      for (let ii = 0; ii < oldValue.length; ii++) {
        let parts = oldValue[ii].split(":");
        let ingredient = parts[0].trim();
        let quantity = parts[1].trim();
        oldValueString = oldValueString + '* ' + ingredient + " - qty: " + quantity + '\n';
      }
      oldValue = oldValueString;

      let newValueString = '';
      for (let ii = 0; ii < newValue.length; ii++) {
        let parts = newValue[ii].split(":");
        let ingredient = parts[0];
        let quantity = parts[1];
        newValueString = newValueString + '* ' + ingredient + " - qty: " + quantity + '\n';
      }
      newValue = newValueString;
    } else if (historyRecord.field === 'is_deleted') {
      if (typeof oldValue == "boolean") {
        oldValue = oldValue ? "True" : "False";
      }
      if (typeof newValue == "boolean") {
        newValue = newValue ? "True" : "False";
      }


    }
    return (
      <tr key={historyDocRef}>
        <td className='history_cell'>{updatedDate}</td>
        <td className='history_cell'>{historyRecord.field}</td>
        <td><div className="scrollable-cell">{oldValue}</div></td>
        <td><div className="scrollable-cell">{newValue}</div></td>
      </tr>
    );
  }

  renderIngredientTableRow = (ingredientDocRef, doc) => {
    let currentIngredient = this.state.ingredientMaps.ingredientMap.get(ingredientDocRef);
    return (
      <tr>
        <td>{doc.description}</td>
        <td>{roundToDollars(doc.cost)}</td>
        <td>{doc.per}</td>
        <td>{doc.quantity}</td>
        <td>{roundToDollars(doc.total_cost)}</td>
        <td>
          <Stack direction="horizontal" gap={2}>
            <Button
              size="sm"
              disabled={this.props.mode === 'View'}
              variant="dark"
              onClick={() => {
                this.toggleDeleteModal(ingredientDocRef, doc.description)
              }}>
              Delete
            </Button>
            <Button
              size="sm"
              disabled={this.props.mode === 'View'}
              variant="dark"
              onClick={() => {
                this.setState({
                  chosenIngredient: currentIngredient,
                  chosenQuantity: doc.quantity,
                }, () => {
                  this.toggleShowForm();
                });
              }}>
              Edit
            </Button>
          </Stack>
        </td>
      </tr>
    );

  }

  getIngredientSelect = (ingredientDocRef, doc) => {
    return (
      <>
        <option value={ingredientDocRef}>{doc.description + '- Cost:' + roundToDollars(doc.cost) + '- Per:' + doc.per}</option>
      </>
    );
  }

  render() {

    let recipeIngredientMap = makeIngredientMap(this.state.recipe.ingredients, this.state.ingredientMaps.ingredientMap);
    let ingredientArray = new Array();
    if (this.state.ingredientMaps && this.state.ingredientMaps.ingredientMap && this.state.ingredientMaps.ingredientMap.size !== 0) {
      ingredientArray = Array.from(this.state.ingredientMaps.ingredientMap.values());
    }
    let historyMap = this.state.historyMap;
    let lastUpdatedString = "";
    let is_deleted = this.state.recipe.is_deleted ? "True" : "False";
    if (this.state.recipe.last_update) {
      lastUpdatedString = this.state.recipe.last_update.toDate().toString();
    }
    //let chosenIngredient = ingredientArray[0];
    let chosenIngredient = undefined;
    if (this.state.chosenIngredient && this.state.chosenIngredient !== '') {
      chosenIngredient = this.state.chosenIngredient;
    }

    return (
      <>
        {
          /* 
          * Recipe Add
          */
        }
        <Container fluid>
          <Modal show={this.state.showForm} onHide={this.handleClose}>
            <Modal.Header closeButton>
              <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {/* <Form onSubmit={this.saveChangedRecipe}> */}
              <Form>
                <Form.Group as={Col}>
                  <Form.Label as={Col} htmlFor="ingredient">Ingredient:</Form.Label>
                  <CustomizedTypeahead
                    id="ingredient"
                    onChange={this.changeChosenIngredient}
                    align='left'
                    labelKey={option => `${option.description} - Cost: ${roundToDollars(option.cost)} - Per: ${option.per}`}
                    options={ingredientArray}
                    defaultSelected={(chosenIngredient ? Array.of(chosenIngredient) : undefined)}
                  //defaultSelected={Array.of('')}
                  />
                </Form.Group>
                <Form.Label as={Col} htmlFor="quantity">Qty:</Form.Label>
                <Form.Group as={Col} className="mb-3">
                  <Form.Control
                    value={this.state.chosenQuantity}
                    required
                    placeholder="0"
                    id="quantity"
                    onChange={this.changeChosenIngredientValue}
                  />
                </Form.Group>
              </Form>

            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" size="sm" onClick={this.toggleShowForm}>
                Cancel
              </Button>{' '}
              <Button variant="secondary" size="sm" onClick={this.addIngredient}>
                Save Ingredient
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={this.state.isDeleteIngredientConfirmOpen}>
            <Container>
              <Row>
                Delete {this.state.deleteDocDescription}?
              </Row>
              <Row>
                <Button variant="dark" size="sm" onClick={() => { this.toggleDeleteModal() }}>Cancel</Button>{'   '}
                <Button variant="dark" size="sm" onClick={() => { this.handleDelete(this.state.deleteDocRef) }}>Confirm</Button>
              </Row>
            </Container>
          </Modal>
          <h1>Recipe {this.props.mode} "{this.state.recipeName}"</h1>
          <Form noValidate validated={this.state.validated} onSubmit={this.saveChangedRecipe}>
            <Button variant="dark" size="sm" onClick={() => { this.props.toggleForm(); }}>
              Cancel
            </Button>{' '}
            <Button
              size="sm"
              disabled={this.props.mode === 'View'}
              variant="dark"
              type="submit">
              Save
            </Button>
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="name">Name:</Form.Label>
                  <Form.Control
                    disabled={this.props.mode === 'View'}
                    required
                    value={this.state.recipe.name}
                    placeholder="Name"
                    id="name"
                    onChange={this.changeValue}
                  />
                </Form.Group>
                <Row className="mb-3">
                  <Form.Label htmlFor="is_deleted">Deleted?:</Form.Label>
                  <ToggleButton
                    passThroughInputProps={{ disabled: this.props.mode === 'View' }}
                    inactiveLabel={'No'}
                    activeLabel={'Yes'}
                    value={this.state.recipe.is_deleted}
                    onToggle={(value) => {
                      let tempRecipe = this.state.recipe;
                      tempRecipe.is_deleted = !tempRecipe.is_deleted;
                      this.setState({
                        recipe: tempRecipe,
                      })
                    }} />
                </Row>
                <Row className="mb-3">
                  <Form.Label as={Col} htmlFor="hours_taken">Hours Taken:</Form.Label>
                  <Form.Label as={Col} htmlFor="makes_qty">Makes:</Form.Label>
                  <Form.Label as={Col} htmlFor="low_profit_index">Lower Profit Index:</Form.Label>
                </Row>
                <Row className="mb-3">
                  <Form.Group as={Col} className="mb-3">
                    <Form.Control
                      disabled={this.props.mode === 'View'}
                      required
                      value={this.state.recipe.hours_taken}
                      placeholder="0"
                      id="hours_taken"
                      onChange={this.changeValue}
                    />
                  </Form.Group>
                  <Form.Group as={Col} className="mb-3">
                    <Form.Control
                      disabled={this.props.mode === 'View'}
                      value={this.state.recipe.makes_qty}
                      placeholder="0"
                      id="makes_qty"
                      onChange={this.changeValue}
                    />
                  </Form.Group>
                  <Form.Group as={Col} className="mb-3">
                    <Form.Select className="mb-3"
                      disabled={this.props.mode === 'View'}
                      required
                      value={this.state.recipe.low_profit_index}
                      id="low_profit_index"
                      onChange={this.changeValue}
                    >
                      <option value='1.6'>1.6 (60% profit)</option>
                      <option value='1.5'>1.5 (50% profit)</option>
                      <option value='1.4'>1.4 (40% profit)</option>
                      <option value='1.3'>1.3 (30% profit)</option>
                      <option value='1.2'>1.2 (20% profit)</option>
                      <option value='1.1'>1.1 (10% profit)</option>
                    </Form.Select>
                  </Form.Group>
                </Row>
              </Col>
              <Col>
                <Row className="mb-3">
                  <Form.Label as={Col} htmlFor="total_ingredient_cost">Total Ingredient Cost:</Form.Label>
                  <InputGroup as={Col} className="mb-3">
                    <Form.Control
                      value={roundToDollars(this.state.recipe.total_ingredient_cost)}
                      aria-label="totalingredientcost"
                      placeholder="0.00"
                      id="total_ingredient_cost"
                      disabled
                    />
                  </InputGroup>
                </Row>
                <Row className="mb-3">
                  <Form.Label as={Col} htmlFor="cost_per_item_high">Cost per Item High Profit:</Form.Label>
                  <InputGroup as={Col} className="mb-3">
                    <Form.Control
                      value={roundToDollars(this.state.recipe.cost_per_item_high)}
                      aria-label="cost_per_item_high"
                      placeholder="0.00"
                      id="cost_per_item_high"
                      disabled
                    />
                  </InputGroup>
                </Row>
                <Row className="mb-3">
                  <Form.Label as={Col} htmlFor="cost_per_item_low">Cost per Item Low Profit:</Form.Label>
                  <InputGroup as={Col} className="mb-3">
                    <Form.Control
                      value={roundToDollars(this.state.recipe.cost_per_item_low)}
                      aria-label="cost_per_item_low"
                      placeholder="0.00"
                      id="cost_per_item_low"
                      disabled
                    />
                  </InputGroup>
                </Row>
                <Row className="mb-3">
                  <Form.Label as={Col} htmlFor="total_batch_cost_high">Total Batch Cost High Profit:</Form.Label>
                  <InputGroup as={Col} className="mb-3">
                    <Form.Control
                      value={roundToDollars(this.state.recipe.total_batch_cost_high)}
                      aria-label="total_batch_cost_high"
                      placeholder="0.00"
                      id="total_batch_cost_high"
                      disabled
                    />
                  </InputGroup>
                </Row>
                <Row className="mb-3">
                  <Form.Label as={Col} htmlFor="total_batch_cost_low">Total Batch Cost Low Profit:</Form.Label>
                  <InputGroup as={Col} className="mb-3">
                    <Form.Control
                      value={roundToDollars(this.state.recipe.total_batch_cost_low)}
                      aria-label="total_batch_cost_low"
                      placeholder="0.00"
                      id="total_batch_cost_low"
                      disabled
                    />
                  </InputGroup>
                </Row>
                <Row className="mb-3">
                  <Form.Label as={Col} htmlFor="total_batch_cost_low">Labor Cost:</Form.Label>
                  <InputGroup as={Col} className="mb-3">
                    <Form.Control
                      value={roundToDollars(this.state.settings.hourly_labor_rate * this.state.recipe.hours_taken)}
                      aria-label="total_batch_cost_low"
                      placeholder="0.00"
                      id="total_batch_cost_low"
                      disabled
                    />
                  </InputGroup>
                </Row>
              </Col>
            </Row>
            <Row className="mb-3">
              <Form.Label as={Col} htmlFor="note">Notes:</Form.Label>
            </Row>
            <Row className="mb-3">
              <Form.Control
                as="textarea"
                disabled={this.props.mode === 'View'}
                value={this.state.recipe.note}
                placeholder="notes..."
                id="note"
                onChange={this.changeValue}
              />
            </Row>
            <Container className="mb-3">
              <Row>
                <Col>
                  <Button
                    size="sm"
                    disabled={this.props.mode === 'View'}
                    variant="dark"
                    onClick={() => {
                      this.setState({
                        chosenIngredient: "",
                        chosenQuantity: 0,
                      }, () => {
                        this.toggleShowForm()
                      });
                    }}>
                    Add Ingredient
                  </Button>
                </Col>
              </Row>
            </Container>
            <Row className="mb-3">
              Ingredients:
            </Row>
            <Row className="mb-3">
              <Table bordered>
                <thead>
                  <tr>
                    <th>Description</th>
                    <th>Cost</th>
                    <th>Per</th>
                    <th>Quantity</th>
                    <th>Total Cost</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    [...recipeIngredientMap].map(([key, value]) => {
                      return this.renderIngredientTableRow(key, value);
                    }
                    )
                  }
                </tbody>
              </Table>
            </Row>
            <Row className="mb-3">
              <Form.Label htmlFor="lastupdated">Last Updated:</Form.Label>
              <Form.Control
                value={lastUpdatedString}
                id="lastupdated"
                disabled
              />
            </Row>
            <Button variant="dark" size="sm" onClick={() => { this.props.toggleForm(); }}>
              Cancel
            </Button>{' '}
            <Button
              size="sm"
              disabled={this.props.mode === 'View'}
              variant="dark"
              type="submit">
              Save
            </Button>
            <Row className="mb-3">
              <Form.Label htmlFor="history">History:</Form.Label>
              <Table
                disabled
                id="history"
                bordered>
                <thead>
                  <tr>
                    <th>Update Date</th>
                    <th>Field</th>
                    <th>Old Value</th>
                    <th>New Value</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    [...historyMap].map(([key, value]) => {
                      return this.renderHistoryTableRow(key, value);
                    }
                    )
                  }
                </tbody>
              </Table>
            </Row>
          </Form>
        </Container>
      </>
    );

  }
}
